import { TTheme } from '@/core/theme'
import { styled } from '@mui/system'
import { alwaysShowScrollbar } from '../digitalFootprint/domainDiscovery/domainDiscovery.styles'
import Typography from '@/ui/components/typography'

export const Wrapper = styled('div')`
    background-color: inherit;
    color: var(--color-greys-800);

    .text {
        color: var(--color-greys-800);
        padding: 4px 0;
    }

    .buttons {
        margin-left: auto;
        margin-right: 30px;
        display: flex;
        gap: 2px;

        div {
            height: 24px;
            width: 80px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-weight: 700;
            font-size: var(--font-size-xs);
            line-height: 15px;
            cursor: pointer;
            transition: all 0.2s linear;
            user-select: none;
            background-color: var(--color-primary);
            color: var(--color-dark-900);

            &:hover {
                background-color: var(--color-primary-700);
            }

            &.is-disabled {
                background-color: var(--color-dark-400);
                cursor: not-allowed;
            }
        }

        .prev {
            border-bottom-left-radius: 12px;
            border-top-left-radius: 12px;
            padding-left: 5px;
        }

        .next {
            border-bottom-right-radius: 12px;
            border-top-right-radius: 12px;
            padding-right: 5px;
        }
    }
`

export const Body = styled('div')<{ theme?: TTheme }>`
    display: flex;
    flex-direction: column;
    width: 100%;
`

export const DescriptionFlex = styled('div')`
    display: flex;
    justify-content: space-between;
    gap: 14px;
    margin: 20px 0;
`

export const ScrollableContainer = styled('div')`
    max-height: calc(100% - 59px);
    overflow-y: auto;
    ${alwaysShowScrollbar}
`

export const Flex = styled('div')`
    display: flex;
    gap: 18px;
    align-items: center;
`

export const HeaderFlex = styled(Flex)`
    align-items: center;
    text-transform: capitalize;
`

export const Title = styled(Typography)`
    color: var(--color-greys-0);
    padding: 0px !important;
`

export const DescriptionTitle = styled(Typography)<{ theme?: TTheme }>`
    color: ${({ theme }) => theme.colors.greys[500]};
    margin-bottom: 6px;
`
